import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'dark' | 'light';
type Mod = 'gab' | 'eleg';

interface ThemeState {
  theme: Theme;
  mod: Mod;
  setTheme: (t: Theme) => void;
  toggleTheme: () => void;
  setMod: (m: Mod) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      mod: 'gab',
      setTheme: (theme) => {
        document.documentElement.setAttribute('data-theme', theme);
        set({ theme });
      },
      toggleTheme: () => {
        const next: Theme = get().theme === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        set({ theme: next });
      },
      setMod: (mod) => {
        document.documentElement.setAttribute('data-mod', mod);
        set({ mod });
      },
    }),
    { name: 'mandato360-theme' },
  ),
);
